import { Routes } from '@angular/router';

import { authGuard } from './core/guards/auth.guard';
import { permissionGuard } from './core/guards/permission.guard';
import { tenantResolvedGuard } from './core/guards/tenant-resolved.guard';

export const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'launch',
  },
  {
    path: 'launch',
    loadComponent: () => import('./features/launch/launch.page').then((m) => m.LaunchPage),
  },
  {
    path: 'tenant',
    loadComponent: () => import('./features/auth/tenant/tenant.page').then((m) => m.TenantPage),
  },
  {
    path: 'login',
    canActivate: [tenantResolvedGuard],
    loadComponent: () => import('./features/auth/login/login.page').then((m) => m.LoginPage),
  },
  {
    path: 'menu',
    canActivate: [authGuard],
    loadComponent: () => import('./features/menu/menu.page').then((m) => m.MenuPage),
  },
  {
    path: 'history',
    canActivate: [authGuard],
    loadComponent: () => import('./features/history/history.page').then((m) => m.HistoryPage),
  },
  {
    path: 'profile',
    canActivate: [authGuard],
    loadComponent: () => import('./features/profile/profile.page').then((m) => m.ProfilePage),
  },
  {
    path: 'receiving',
    canActivate: [authGuard, permissionGuard],
    loadComponent: () => import('./features/receiving/receiving.page').then((m) => m.ReceivingPage),
  },
  {
    path: 'inquiry/sku',
    canActivate: [authGuard, permissionGuard],
    loadComponent: () => import('./features/inquiry/sku/sku-inquiry.page').then((m) => m.SkuInquiryPage),
  },
  {
    path: 'inquiry/location',
    canActivate: [authGuard, permissionGuard],
    loadComponent: () => import('./features/inquiry/location/location-inquiry.page').then((m) => m.LocationInquiryPage),
  },
  {
    path: 'inquiry/container',
    canActivate: [authGuard, permissionGuard],
    loadComponent: () => import('./features/inquiry/container/container-inquiry.page').then((m) => m.ContainerInquiryPage),
  },
  {
    path: 'inquiry/staging',
    canActivate: [authGuard, permissionGuard],
    loadComponent: () => import('./features/inquiry/staging/staging-inquiry.page').then((m) => m.StagingInquiryPage),
  },
  {
    path: 'inquiry/pi/sku',
    canActivate: [authGuard, permissionGuard],
    loadComponent: () => import('./features/inquiry/pi-sku/pi-sku-inquiry.page').then((m) => m.PiSkuInquiryPage),
  },
  {
    path: 'inquiry/pi/csn',
    canActivate: [authGuard, permissionGuard],
    loadComponent: () => import('./features/inquiry/pi-csn/pi-csn-inquiry.page').then((m) => m.PiCsnInquiryPage),
  },
  {
    path: 'inquiry/pi/location',
    canActivate: [authGuard, permissionGuard],
    loadComponent: () => import('./features/inquiry/pi-location/pi-location-inquiry.page').then((m) => m.PiLocationInquiryPage),
  },
  {
    path: 'outbound-move',
    canActivate: [authGuard, permissionGuard],
    loadComponent: () => import('./features/outbound-move/outbound-move.page').then((m) => m.OutboundMovePage),
  },
  {
    path: 'ship-carton-tracking',
    canActivate: [authGuard, permissionGuard],
    loadComponent: () => import('./features/ship-carton-tracking/ship-carton-tracking.page').then((m) => m.ShipCartonTrackingPage),
  },
  {
    path: 'full-case-sub-wave',
    canActivate: [authGuard, permissionGuard],
    loadComponent: () => import('./features/full-case-sub-wave/full-case-sub-wave.page').then((m) => m.FullCaseSubWavePage),
  },
  {
    path: 'pallet-add-remove',
    canActivate: [authGuard, permissionGuard],
    loadComponent: () => import('./features/pallet-add-remove/pallet-add-remove.page').then((m) => m.PalletAddRemovePage),
  },
  {
    path: 'move-pick-cart-inv',
    canActivate: [authGuard, permissionGuard],
    loadComponent: () => import('./features/move-pick-cart-inv/move-pick-cart-inv.page').then((m) => m.MovePickCartInvPage),
  },
  {
    path: 'move-pick-cart',
    canActivate: [authGuard, permissionGuard],
    loadComponent: () => import('./features/move-pick-cart/move-pick-cart.page').then((m) => m.MovePickCartPage),
  },
  {
    path: 'receiving-adjustment',
    canActivate: [authGuard, permissionGuard],
    loadComponent: () => import('./features/receiving-adjustment/receiving-adjustment.page').then((m) => m.ReceivingAdjustmentPage),
  },
  {
    path: 'move-inventory',
    canActivate: [authGuard, permissionGuard],
    loadComponent: () => import('./features/move-inventory/move-inventory.page').then((m) => m.MoveInventoryPage),
  },
  {
    path: 'inventory-adjust',
    canActivate: [authGuard, permissionGuard],
    loadComponent: () => import('./features/inventory-adjust/inventory-adjust.page').then((m) => m.InventoryAdjustPage),
  },
  {
    path: 'messages/:type',
    canActivate: [authGuard],
    loadComponent: () => import('./features/support/message/message.page').then((m) => m.MessagePage),
  },
  {
    path: 'settings',
    canActivate: [authGuard],
    loadComponent: () => import('./features/settings/settings.page').then((m) => m.SettingsPage),
  },
  {
    path: 'putaway',
    canActivate: [authGuard, permissionGuard],
    loadComponent: () => import('./features/putaway/putaway.page').then((m) => m.PutawayPage),
  },
  {
    path: 'replenishment',
    canActivate: [authGuard, permissionGuard],
    loadComponent: () => import('./features/replenishment/replenishment.page').then((m) => m.ReplenishmentPage),
  },
  {
    path: 'outbound-sort',
    canActivate: [authGuard, permissionGuard],
    loadComponent: () => import('./features/outbound-sort/outbound-sort.page').then((m) => m.OutboundSortPage),
  },
  {
    path: 'singles-pack',
    canActivate: [authGuard, permissionGuard],
    loadComponent: () => import('./features/singles-pack/singles-pack.page').then((m) => m.SinglesPackPage),
  },
  {
    path: 'pack-verify',
    canActivate: [authGuard, permissionGuard],
    loadComponent: () => import('./features/pack-verify/pack-verify.page').then((m) => m.PackVerifyPage),
  },
  {
    path: 'picking',
    canActivate: [authGuard, permissionGuard],
    loadComponent: () => import('./features/picking/picking.page').then((m) => m.PickingPage),
  },
  {
    path: 'repicking',
    canActivate: [authGuard, permissionGuard],
    loadComponent: () => import('./features/repicking/repicking.page').then((m) => m.RepickingPage),
  },
  {
    path: 'cycle-count',
    canActivate: [authGuard, permissionGuard],
    loadComponent: () => import('./features/cycle-count/cycle-count.page').then((m) => m.CycleCountPage),
  },
  {
    path: 'pi-count',
    canActivate: [authGuard, permissionGuard],
    loadComponent: () => import('./features/pi-count/pi-count.page').then((m) => m.PiCountPage),
  },
  {
    path: 'move-cart-from-chute',
    canActivate: [authGuard, permissionGuard],
    loadComponent: () => import('./features/move-cart-from-chute/move-cart-from-chute.page').then((m) => m.MoveCartFromChutePage),
  },
  {
    path: 'url-error',
    loadComponent: () =>
      import('./features/support/url-error/url-error.page').then((m) => m.UrlErrorPage),
  },
  {
    path: 'session-expired',
    loadComponent: () =>
      import('./features/support/session-expired/session-expired.page').then((m) => m.SessionExpiredPage),
  },
  {
    path: 'not-authorized',
    loadComponent: () =>
      import('./features/support/not-authorized/not-authorized.page').then((m) => m.NotAuthorizedPage),
  },
  {
    path: '**',
    loadComponent: () => import('./features/support/not-found/not-found.page').then((m) => m.NotFoundPage),
  },
];
